<template>
  <div
    class="cn-color-select"
    :class="{
      'cn-color-select--large': large,
    }"
  >
    <component
      :is="clickable ? 'UiLink' : 'button'"
      v-for="(item, i) in items"
      :key="i"
      :to="item.slug && item.slug"
      class="cn-color-select__color"
      :class="[
        { 'cn-color-select__color--active': activeColor === item.color },
      ]"
      :style="`--ab-canyon-color-select-color-bg: ${item.color}`"
      @click="setColor(item.color, i)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  clickable?: boolean;
  items?: Array<{ slug: string | null; color: string }>;
  large?: boolean;
  activeSimilarProduct?: { color: string } | null;
}

const props = withDefaults(defineProps<Props>(), {
  clickable: false,
  items: () => [],
  large: false,
  activeSimilarProduct: null,
});
const emit = defineEmits<{ (e: 'input', value: number): void }>();

const activeColor = ref(
  props.activeSimilarProduct
    ? props.activeSimilarProduct.color
    : props.items[0]?.color,
);

const setColor = (color: string, index: number) => {
  if (props.clickable) return;

  if (activeColor.value === color) return;

  activeColor.value = color;
  emit('input', index);
};
</script>

<style lang="scss">
.cn-color-select {
  --ab-canyon-color-select-color-bg: var(--ab-canyon-color-light);
  --ab-canyon-color-select-color-shadow-ring: var(--ab-canyon-color-light);
  --ab-canyon-color-select-color-shadow-ring-inner: var(
    --ab-canyon-color-light
  );
  --ab-canyon-color-select-color-shadow-ring-active: var(
    --ab-canyon-color-neutral-dark
  );
  --ab-canyon-color-select-color-border: var(--ab-canyon-color-neutral);

  padding-left: var(--size-base);
  padding-right: var(--size-base);
  display: flex;
  column-gap: var(--size-base);
  &__color {
    background-color: var(--ab-canyon-color-select-color-bg);
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    box-shadow:
      var(--ab-canyon-color-select-color-shadow-ring-inner) 0 0 0 2px,
      var(--ab-canyon-color-select-color-shadow-ring) 0 0 0 4px,
      #0000 0 0 0 0;
    border-color: var(--ab-canyon-color-select-color-border);
    border-width: 1px;
    transform: rotate(30deg) skewY(-30deg);
    width: var(--size-xs);
    height: var(--size-lg);
    &--active {
      --ab-canyon-color-select-color-shadow-ring: var(
        --ab-canyon-color-select-color-shadow-ring-active
      );

      transform: rotate(30deg) skewY(-30deg) scaleX(1.1) scaleY(1.1);
    }
  }
  &--large {
    column-gap: var(--size-xl);
    .cn-color-select {
      &__color {
        box-shadow:
          var(--ab-canyon-color-select-color-shadow-ring-inner) 0 0 0 4px,
          var(--ab-canyon-color-select-color-shadow-ring) 0 0 0 6px,
          #0000 0 0 0 0;
        width: var(--size-base);
        height: 1.75rem;
      }
    }
  }
}
</style>
